import { Outlet, useLocation } from 'react-router-dom'
import { useSessao } from '../../auth/contexto'
import { caminhosRestritosA } from '../../lib/navegacao'
import { SemAcesso } from './SemAcesso'

/**
 * Portão das telas que só existem para o lado CONTRATANTE.
 *
 * **Isto não é a autorização.** A autorização é `@PreAuthorize(Autorizacoes.CONTRATANTE)` no
 * servidor, e ela continua valendo se esta camada não existir. O que se resolve aqui é o que a
 * pessoa vê: sem o portão, quem digita `/fiscalizacao` chega numa tela que monta, dispara a
 * consulta, toma 403 e fica com uma caixa de erro técnica no meio de um layout normal — o que se
 * lê como defeito do sistema, não como limite de acesso.
 *
 * As rotas protegidas saem do registro de navegação (`organizacao: 'CONTRATANTE'`), e não de uma
 * lista escrita aqui: duas listas divergem, e a que divergiria seria justamente esta, a que
 * ninguém olha depois de escrever.
 *
 * @returns a tela pedida, ou a recusa explicada
 */
export function RotaDoContratante() {
  const { usuario } = useSessao()
  const local = useLocation()

  const restritas = caminhosRestritosA('CONTRATANTE')
  const restrita = restritas.some((rota) => local.pathname === rota || local.pathname.startsWith(`${rota}/`))

  if (restrita && usuario?.papelContratual !== 'CONTRATANTE') {
    return <SemAcesso />
  }

  return <Outlet />
}
